import { render } from "./addCourse.vue?vue&type=template&id=e3536244&scoped=true&ts=true"
import script from "./addCourse.vue?vue&type=script&lang=ts"
export * from "./addCourse.vue?vue&type=script&lang=ts"

import "./addCourse.vue?vue&type=style&index=0&id=e3536244&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3536244"]])

export default __exports__